import { render, staticRenderFns } from "./Accept_Connect.vue?vue&type=template&id=5d10ea69"
import script from "./Accept_Connect.vue?vue&type=script&lang=js"
export * from "./Accept_Connect.vue?vue&type=script&lang=js"
import style0 from "./Accept_Connect.vue?vue&type=style&index=0&id=5d10ea69&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports